import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function addToCart(quoteId: string, sku: string, qty: string): Promise<[]> {
  //console.log('Adding to cart:', { quoteId, sku, qty });
  return new AxiosRequestSender(client)
    .setUrl('addToCart')
    .setMethod('POST')
    .setProps([{quoteId, sku, qty}])
    .send();
}
